import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { RequestTypes } from '../requestTypes'
import { companyKeys } from '../companyKeys'

interface BulkDownloadCompaniesResponse {
  downloadUrl: string
  downloadDirectUrl: string
  fileKey: string
}

export const useBulkDownloadCompanies = (
  options?: UseMutationOptions<
    BulkDownloadCompaniesResponse,
    RequestErrorType,
    RequestTypes['bulkDownloadCompanies']
  >,
) => {
  return useMutation({
    ...companyKeys.bulkDownloadCompanies,
    ...options,
  })
}
